import { render, staticRenderFns } from "./addFaq.vue?vue&type=template&id=52ff04f1&scoped=true&lang=html&"
import script from "./addFaq.vue?vue&type=script&lang=js&"
export * from "./addFaq.vue?vue&type=script&lang=js&"
import style0 from "./addFaq.vue?vue&type=style&index=0&id=52ff04f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ff04f1",
  null
  
)

export default component.exports